import CharacterSpellPane from './CharacterSpellPane';

export default CharacterSpellPane;
export { CharacterSpellPane };
